import { Component, OnInit, ViewChild, DebugNode } from '@angular/core';
import { ScholarshipDetail } from '../Models/scholarshipdetail.model';
import { SchoolarshipDetailService } from './scholarshipdetail.service';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService, NgxSpinnerComponent } from 'ngx-spinner';
import { HttpErrorResponse } from '@angular/common/http';
import { global } from '../../shared/global';
import { Router, ActivatedRoute } from "@angular/router";
declare var $: any;

@Component({
  selector: 'app-scholarshipdetail',
  templateUrl: './scholarshipdetail.component.html',
  styleUrls: ['./scholarshipdetail.component.css']
})
export class ScholarshipdetailComponent implements OnInit {
  @ViewChild('scholarshipDetail') scholarshipDetail: NgForm;
  data: ScholarshipDetail;
  dropDownData: any;
  scholarshiptypes: any
  responseData: any;
  scholarshipDetailList: Array<any>;
  isDesc: boolean;
  column: string;
  p: number = 1;
  pageLimit = global.pageLimit;
  submitted: boolean;
  searchtext: any;
  HashCode: any;
  btnsubmittext = "Add";
  schoolname;
  std: any;
  years: any;
  mediums: any;
  constructor(private service: SchoolarshipDetailService, private toastr: ToastrService, private spinner: NgxSpinnerService, private router: Router, private rout: ActivatedRoute) { }

  ngOnInit(): void {
    if (localStorage.length == 0) {
      this.router.navigate(['/aciadmin']);
      return;
    }
    if (this.rout.snapshot.paramMap.has('ID')) {
      this.HashCode = this.rout.snapshot.paramMap.get('ID');
      this.schoolname = "- (" + localStorage.getItem("SchoolName") + ")";
      if (this.HashCode.trim() == "") {
        this.router.navigate(['/registrationlist']);
        return;
      }
    } else {
      this.router.navigate(['/registrationlist']);
      return;
    }
    this.data = new ScholarshipDetail();
    this.getScholarshipDetailList();
    this.fillScholarshipType();
    this.fillStandard();
    this.fillMedium();
    this.fillAcademicYear();
  }
  fillStandard() {
    const data = {
      HashCode: this.HashCode
    };
    this.service.fillStandard(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.std = this.dropDownData.dropdownlist;
        this.data.StandardID = 0;
      });
  }
  fillMedium() {
    const data = {
      HashCode: this.HashCode
    };
    this.service.fillMedium(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.mediums = this.dropDownData.dropdownlist;
        this.data.MediumID = 0;
      });
  }
  fillAcademicYear() {
    const data = {
      HashCode: this.HashCode
    };
    this.service.fillAcademicYear(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.years = this.dropDownData.dropdownlist;
        this.years.splice(0, 1);
        this.years.reverse();
        this.data.AcademicYearID = this.years.length;
      });
  }
  fillScholarshipType() {
    const data = {
      //HashCode: this.HashCode
    };
    this.service.fillScholarshipType(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.scholarshiptypes = this.dropDownData.dropdownlist;
        this.data.ScholarshipTypeID = 0;
      });
  }
  getScholarshipDetailList() {
    this.spinner.show();
    const data = {
      HashCode: this.HashCode
    };
    this.service.getScholarshipDetailList(data)
      .subscribe(data => {
        this.responseData = data;
        this.spinner.hide();
        this.scholarshipDetailList = undefined;
        if (this.responseData.tokenStatus == false) {
          localStorage.clear();
          this.toastr.error(this.responseData.message);
          this.router.navigate(['/aciadmin']);
        }
        if(!this.responseData.userRightsStatus){
          this.toastr.error(this.responseData.message);
          return;
        }
        if (this.responseData.status == false) {
          //this.toastr.error(this.responseData.message);
          return
        }
        else {
          this.spinner.show();
          this.scholarshipDetailList = this.responseData.ScholarshipDetailLists;
          this.spinner.hide();
        }
      }, (err: HttpErrorResponse) => {
        localStorage.clear();
        this.spinner.hide();
        this.toastr.error('Something Went Wrong');
        this.router.navigate(['/aciadmin']);
      });
  }
  onSubmit(data) {
    this.submitted = true;
    if (this.data.ScholarshipTypeID == 0 || this.data.StandardID == 0 || this.data.MediumID == 0 || this.data.AcademicYearID == 0) {
      return;
    }
    if (this.data.Amount <= 0) {
      this.toastr.error("Amout should be greater then zero");
      return;
    }
    if (this.data.GrNo == '0') {
      this.toastr.error("Gr. no. should be greater then zero");
      return;
    }
    if (this.data.StudName.trim().length == 0) {
      this.toastr.error("Enter student name");
      return;
    }
    this.data.HashCode = this.HashCode;
    if (this.scholarshipDetail.valid) {
      this.spinner.show();
      this.service.saveScholarshipDetail(this.data)
        .subscribe(data => {
          this.responseData = data;
          this.spinner.hide();
          if (this.responseData.tokenStatus == false) {
            localStorage.clear();
            this.toastr.error(this.responseData.message);
            this.router.navigate(['/aciadmin']);
          }
          if(!this.responseData.userRightsStatus){
            this.toastr.error(this.responseData.message);
            return;
          }
          if (this.responseData.status == false) {
            this.toastr.error(this.responseData.message);
            return
          }
          else {
            this.getScholarshipDetailList();
            this.toastr.success(this.responseData.message);
            this.resetForm();
          }
        }, (err: HttpErrorResponse) => {
          localStorage.clear();
          this.spinner.hide();
          this.toastr.error('Something Went Wrong');
          this.router.navigate(['/aciadmin']);
        });
    }
  }
  editScholarshipDetail(HashCode) {
    this.spinner.show();
    const data = {
      HashCode: HashCode
    };
    this.service.getScholarshipDetailByID(data)
      .subscribe(data => {
        this.responseData = data;
        this.spinner.hide();
        if (this.responseData.tokenStatus == false) {
          this.toastr.error(this.responseData.message);
          return
        }
        if(!this.responseData.userRightsStatus){
          this.toastr.error(this.responseData.message);
          return;
        }
        if (this.responseData.status == false) {
          this.toastr.error(this.responseData.message);
          return
        }
        else {
          this.spinner.hide();
          this.data = this.responseData;
          this.btnsubmittext = "Update";
        }
      }, (err: HttpErrorResponse) => {
        localStorage.clear();
        this.spinner.hide();
        this.toastr.error('Something Went Wrong');
        this.router.navigate(['/aciadmin']);
      });
  }
  deleteScholarshipDetail(HashCode) {
    var a = confirm("Are you sure you want to delete ?");
    if (a) {
      const data = {
        HashCode: HashCode
      }
      this.spinner.show();
      this.service.deleteScholarshipDetail(data)
        .subscribe(data => {
          this.responseData = data;
          this.spinner.hide();
          if (this.responseData.tokenStatus == false) {
            this.toastr.error(this.responseData.message);
            return
          }
          if(!this.responseData.userRightsStatus){
            this.toastr.error(this.responseData.message);
            return;
          }
          if (this.responseData.status == false) {
            this.toastr.error(this.responseData.message);
            return
          }
          else {
            this.toastr.success(this.responseData.message);
            this.getScholarshipDetailList();
            this.resetForm();
          }
        }, (err: HttpErrorResponse) => {
          localStorage.clear();
          this.spinner.hide();
          this.toastr.error('Something Went Wrong');
          this.router.navigate(['/aciadmin']);
        });
    }
  }
  onlyDouble(evt, val) {
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;
    if (charCode == 46 && val != undefined && String(val).includes('.'))
      return false;
    var i = String(val).indexOf('.');
    if (i > 0 && String(val).length > i + 2)
      return false
    return true;
  }
  sortBy(field: string) {
    this.isDesc = !this.isDesc;
    this.column = field;
    let direction = this.isDesc ? 1 : -1;

    this.scholarshipDetailList.sort(function (a, b) {
      if (a[field] < b[field]) {
        return -1 * direction;
      }
      else if (a[field] > b[field]) {
        return 1 * direction;
      }
      else {
        return 0;
      }
    });
  }
  setpage() {
    this.p = 1;
  }
  resetForm() {
    this.data.ID = 0;
    this.data.AcademicYearID = this.years.length;
    this.data.StandardID = 0;
    this.data.MediumID = 0;
    this.data.HashCode = null;
    this.data.Amount = null;
    this.data.ScholarshipTypeID = 0;
    this.data.GrNo = null;
    this.data.StudName = null;
    this.submitted = false;
    this.btnsubmittext = "Add";
  }
  Cancel() {
    this.router.navigate(['/registrationlist']);
  }
}
